<!-- home.component.html -->
<app-layout>
    <router-outlet></router-outlet>
</app-layout>




  


